import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import FileRejectModal, { IDispatchProps, IProps } from './index';
import { ApplicationState } from '../../../../store';
import { closeModal } from '../../../../store/ui/actions';
import { rejectDoc } from '../../../../store/student/documents/actions';
import {
  rejectDoc as rejectFinanceDoc,
  // toggleRequiredDocs
} from '../../../../store/student/financeDocuments/actions';

import {
  rejectDoc as rejectFollowUpDocs,
  // toggleRequiredDocs
} from '../../../../store/student/followUpDocuments/actions';

import {
  saveMessage,
  // saveFinanceDocuments
} from '../../../../store/student/actions';
import { getDocDetails } from '../../../../utilities/documents';
import { getDisplayName } from '../../../../utilities/formatting';
import { IDocument, IMessage } from 'api-paths-cas';
import getRequestNewDocumentDefaultValue from './helpers/getRequestNewDocumentDefaultValue';

const mapStateToProps = (state: ApplicationState): IProps => {
  const { openModal } = state.ui;
  const { sponsorType, docType, sponsorKey, docKey, modalTitle, isFinanceDocumentModal, isFollowUpDocumentModal } =
    openModal || {};
  let rejectDocType = docType ? docType.split('reject-')[1] : '';
  // special case 'customRequest' has no docType only sponsorType
  if (rejectDocType === 'null') {
    rejectDocType = null;
  }

  const docs = {
    ...(isFinanceDocumentModal ? { ...state.student.financeDocuments } : {}),
    ...(isFollowUpDocumentModal ? { ...state.student.followUpDocuments } : {}),
    ...(!isFinanceDocumentModal && !isFollowUpDocumentModal ? { ...state.student.documents } : {}),
  };
  const docDetails = getDocDetails({
    docs,
    sponsorType,
    docType: rejectDocType ?? null,
    docKey: docKey ?? null,
    sponsorKey: sponsorKey ?? null,
  });
  const requestNewDocumentDefault = getRequestNewDocumentDefaultValue({
    docs,
    sponsorType,
    docType: rejectDocType ?? null,
    docKey: docKey ?? null,
    sponsorKey: sponsorKey ?? null,
  });

  return {
    docUserAccess: docDetails.userAccess,
    sponsorType,
    docType: rejectDocType ?? null,
    sponsorKey: sponsorKey ?? null,
    docKey: docKey ?? null,
    modalTitle,
    userName: state.auth.student_number!,
    displayName: getDisplayName(state.auth, state.config),
    isFinanceDocumentModal: isFinanceDocumentModal ?? false,
    isFollowUpDocumentModal: isFollowUpDocumentModal ?? false,
    financeDocuments: state.student.financeDocuments,
    role: state.auth.role,
    requestNewDocumentDefault,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onClose: () => dispatch(closeModal()),
  onRejectDoc: (
    message: IMessage,
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    reason: string,
    status: IDocument['status'],
    isFinDoc: boolean,
    isFollowUpDocs: boolean,
    isCustomDocRequested: boolean,
  ) => {
    if (isFinDoc) {
      dispatch(rejectFinanceDoc(sponsorType, sponsorKey, docType, docKey, status, reason || '', isCustomDocRequested));
    } else if (isFollowUpDocs) {
      dispatch(rejectFollowUpDocs(sponsorType, sponsorKey, docType, docKey, status, reason || ''));
    } else {
      dispatch(rejectDoc(sponsorType, sponsorKey, docType, docKey, status, reason || ''));
    }
    dispatch(saveMessage(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FileRejectModal);
